export const FiatSendSteps = {
  CONTACT_OR_BENEFICIARY_SELECTOR: 'contact_or_beneficiary_selector',
  CONTACT_BANK_ACCOUNT: 'contact_bank_account',
  BENEFICIARY: 'beneficiary',
  DETAILS: 'details',
  CONFIRMATION: 'confirmation',
  EOF: 'eof',
} as const

export type FiatSendStep = (typeof FiatSendSteps)[keyof typeof FiatSendSteps]

export const ConvertStep = {
  DETAILS: 'details',
  REVIEW: 'review',
  COMPLETE: 'complete',
} as const

export type ConvertStep = (typeof ConvertStep)[keyof typeof ConvertStep]
